module.exports = __webpack_public_path__ + "img/a11.3be25f33.svg";